export const LogoMark = ({ size = 40, className = "" }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        className={className}
        aria-hidden="true"
    >
        <path d="M10 56 L10 8 M10 8 L6 14 M10 8 L14 14" stroke="#F8FAFC" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 54 L58 54 M58 54 L52 50 M58 54 L52 58" stroke="#F8FAFC" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M10 54 C 16 28, 24 20, 56 16"
            stroke="#38BDF8" strokeWidth="3.5" strokeLinecap="round"
        />
        <path d="M18 33 L18 54 M18 33 L10 33" stroke="#38BDF8" strokeWidth="1.5" strokeDasharray="3 3" opacity="0.7" />
        <circle cx="18" cy="33" r="3.5" fill="#38BDF8" />
    </svg>
);
